import {Button, Combobox, Flex, TextInput} from "@mantine/core";
import React, {Dispatch, SetStateAction, useState} from "react";
import {SearchQuery} from "../../../api/calendar/event/CalendarEventApi";
import {useForm} from "@mantine/form";
import DevicePickerDialog from "../../../components/picker-dialog/DevicePickerDialog";
import ClearButton = Combobox.ClearButton;
import {Device} from "../../../api/device/DeviceApi";

type Props = {
    query: SearchQuery;
    setQuery: Dispatch<SetStateAction<SearchQuery>>;
}

export const CalendarEventFilters = (props: Props) => {
    const {query, setQuery} = props;

    const [deviceModal, setDeviceModal] = useState(false);
    const [selectedDevice, setSelectedDevice] = useState<Device>();

    const form = useForm({
        initialValues: {
            q: query.q || '',
            unit: query.unit || '',
        }
    });

    const handleSubmit = (values: Pick<SearchQuery, "q" | "unit">) => {
        setQuery({
            ...query,
            q: values.q !== '' ? values.q : undefined,
            unit: selectedDevice?.unit,
        });
    }

    return (
        <form onSubmit={form.onSubmit(handleSubmit)}>
            <Flex direction="row" align="center" gap="md">
                <TextInput
                    key={form.key('q')}
                    placeholder="Szukaj..."
                    style={{width: '200px'}}
                    {...form.getInputProps("q")}
                />

                <TextInput
                    readOnly
                    style={{ width: '300px' }}
                    placeholder="Jednostka"
                    value={selectedDevice ? `(${selectedDevice.unit}) ${selectedDevice.name}` : '-'}
                    onClick={() => setDeviceModal(true)}
                    rightSection={
                        <ClearButton onClear={function (): void {
                            setSelectedDevice(undefined);
                        } }/>
                    }
                />

                <DevicePickerDialog
                    setDevice={setSelectedDevice}
                    isOpen={deviceModal}
                    justClose={() => setDeviceModal(false)}
                />

                <Button
                    size="sm"
                    type="submit"
                    children="Szukaj..."
                />
            </Flex>
        </form>
    )
}